export enum GroupState {
    Ingresado = "001",
    EnProceso = "002",
    Terminado = "003",
    Agendado  = "004",
    Pausado  = "005",
    PorPausar = "006",
    Eliminado  = "007",
    Limbo = "008",
    InDeleted = "009"
}
